// extracted by mini-css-extract-plugin
export default {"tabPanelWrapper":"styles_tabPanelWrapper__16sSj"};